import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=46424138&"
import script from "./CreateProfile.vue?vue&type=script&lang=js&"
export * from "./CreateProfile.vue?vue&type=script&lang=js&"
import style0 from "./CreateProfile.vue?vue&type=style&index=0&id=46424138&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports